export default "__VITE_ASSET__BObqsfei__"